import React, { useState } from 'react';
import AppButton from 'src/components/base/Button/Button';
import MiniCheckBox from 'src/components/modules/MiniCheckBox/MiniCheckBox';
import './EhrConnectionIssueTodo.scss';
import { clearModalContent } from 'src/redux/modules/modalEvent';
import { useDispatch } from 'react-redux';
import { updateIfollowedUpTodo } from 'src/redux/services/loggingServices';
import { Logger } from 'src/latest/src/services/ConsoleLogger';
import { TodoTypeEnums } from 'src/latest/src/constants';
import { useTranslation } from 'react-i18next';
import { changeTodoStatusV1 } from 'src/api/user';
import { addFlashNotification } from 'src/redux/modules/flashNotification';

type Props = {
  todo: any;
  onVerified: () => void;
};

const EhrConnectionIssueTodo: React.FC<Props> = ({ onVerified, todo }) => {
  const [checked, setChecked] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean | 'clear' | 'pending'>(false);

  const { t } = useTranslation('components');
  const dispatch = useDispatch();

  const createFollowUp = async () => {
    const respObj = {
      follow_up_by: [TodoTypeEnums.SELF],
      note: ``,
    };

    try {
      setLoading('clear');
      await updateIfollowedUpTodo(todo.id, respObj);
      dispatch(clearModalContent());
      onVerified();
    } catch (e) {
      dispatch(
        addFlashNotification({
          message: t('ehrConnectionIssueTodo.errors.followUp'),
          isError: true,
          dedupeKey: `followup_error_${todo.id}`,
        }),
      );
      Logger.log(t('ehrConnectionIssueTodo.errors.followUp'), e);
    } finally {
      setLoading(false);
    }
  };

  const markToDoAsPending = async () => {
    setLoading('pending');

    try {
      await changeTodoStatusV1(todo.id, false, '');
      onVerified();
      dispatch(clearModalContent());
    } catch (e) {
      dispatch(
        addFlashNotification({
          message: t('ehrConnectionIssueTodo.errors.pending'),
          isError: true,
          dedupeKey: `pending_error_${todo.id}`,
        }),
      );
      Logger.log(t('ehrConnectionIssueTodo.errors.pending'), e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ehr-connection-todo-container">
      <div className="description">
        {t('ehrConnectionIssueTodo.description', {
          patientName: todo?.user_full_name,
        })}
      </div>

      <div className="checkbox-container d-flex justify-content-between mt-5 mb-4">
        <MiniCheckBox
          text={t('ehrConnectionIssueTodo.checkbox')}
          isCheckFirst={true}
          isActive={checked}
          onClick={() => setChecked(!checked)}
          value={checked}
        />
      </div>

      <div className="d-flex justify-content-center mt-3">
        <AppButton
          label={t('ehrConnectionIssueTodo.clearButton')}
          textWeight="bold"
          textSize="size-14"
          isProcessing={loading === 'clear'}
          disabled={!!loading || !checked}
          className="m-2 primary no-border clear-todo-button"
          onClick={() => {
            createFollowUp();
          }}
        />

        <AppButton
          label={t('ehrConnectionIssueTodo.moveToPendingButton')}
          textWeight="bold"
          textSize="size-14"
          variant="light"
          isProcessing={loading === 'pending'}
          disabled={!!loading || todo.active === false}
          className="m-2 bg-white"
          onClick={markToDoAsPending}
        />
      </div>
    </div>
  );
};

export default EhrConnectionIssueTodo;
